export default __webpack_public_path__ + "static/sesame-2-93d9366271d6c39a8061a48c6ced5461.webp";